import { getCookie, log, storage } from '@guardian/libs';
import { BrazeMessages, LocalMessageCache, NullBrazeMessages, } from '@guardian/braze-components/logic';
import { hasCurrentBrazeUser, setHasCurrentBrazeUser, clearHasCurrentBrazeUser, } from '@root/src/web/lib/hasCurrentBrazeUser';
import { initPerf } from '@root/src/web/browser/initPerf';
import { record } from '@root/src/web/browser/ophan/ophan';
import { checkBrazeDependencies } from './checkBrazeDependencies';
import { getInitialisedAppboy } from './initialiseAppboy';
const maybeWipeUserData = async (apiKey, brazeUuid, consent) => {
    const userHasLoggedOut = !brazeUuid && hasCurrentBrazeUser();
    const userHasRemovedConsent = !consent && hasCurrentBrazeUser();
    if (userHasLoggedOut || userHasRemovedConsent) {
        try {
            if (apiKey) {
                const appboy = await getInitialisedAppboy(apiKey);
                appboy.wipeData();
            }
            LocalMessageCache.clear();
            clearHasCurrentBrazeUser();
        }
        catch (error) {
            window.guardian.modules.sentry.reportError(
            // @ts-expect-error
            error, 'braze-maybeWipeUserData');
        }
    }
};
export const buildBrazeMessages = async (idApiUrl) => {
    if (!storage.local.isAvailable()) {
        return new NullBrazeMessages();
    }
    const isSignedIn = !!getCookie({ name: 'GU_U', shouldMemoize: true });
    const dependenciesResult = await checkBrazeDependencies(isSignedIn, idApiUrl);
    if (!dependenciesResult.isSuccessful) {
        const { failure, data } = dependenciesResult;
        log('tx', `Not attempting to show Braze messages. Dependency ${failure.field} failed with ${failure.data}.`);
        await maybeWipeUserData(data.apiKey, data.brazeUuid, data.consent);
        return new NullBrazeMessages();
    }
    try {
        const sdkLoadTiming = initPerf('braze-sdk-load');
        sdkLoadTiming.start();
        const appboy = await getInitialisedAppboy(dependenciesResult.data.apiKey);
        const sdkLoadTimeTaken = sdkLoadTiming.end();
        record({
            component: 'braze-sdk-load-timing',
            value: sdkLoadTimeTaken,
        });
        const errorHandler = (error, desc) => {
            window.guardian.modules.sentry.reportError(error, desc);
        };
        const brazeMessages = new BrazeMessages(appboy, LocalMessageCache, errorHandler);
        setHasCurrentBrazeUser();
        appboy.changeUser(dependenciesResult.data.brazeUuid);
        appboy.openSession();
        return brazeMessages;
    }
    catch {
        return new NullBrazeMessages();
    }
};
